import React, {useState, useEffect} from "react";
import CohortComp from "../Comparators/CohortComp";
import AgeComp from "../Comparators/AgeComp";
import SexComp from "../Comparators/SexComp";
import YearComp from "../Comparators/YearsComp";
import StateComp from "../Comparators/StateComp";
import InsuranceComp from "../Comparators/InsuranceComp";
import useStateType from "../Stores/StateStore";

const ComparatorSelection: React.FC<{
  displayValue: number;
  comparator: string;
}> = ({displayValue, comparator}): JSX.Element => {
  const stateCompValue = useStateType((s) => s.stateCompValue);

  const [tempSelection, setTempSelection] = useState<string[]>(stateCompValue);
  const setStateCompValue = useStateType((s) => s.setStateCompValue);

  function resetStates() {
    setStateCompValue([]);
    setTempSelection([]);
  }
  return (
    <div className="flex flex-col items-center w-full max-h-[200px] rounded-3xl bg-valmainheart px-2 py-2">
      {comparator === "State" ? (
        <div className="flex-1 w-full overflow-y-auto rounded-3xl bg-valmainheart p-2 ">
          <div className="text-valmidnight font-bold font-caption-1! ml-3 flex flex-row justify-between">
            <div className="text-5xl "> State</div>
            <button
              className="text-base font-bold text-valmidnight font-caption-1! mb-1 underline"
              onClick={resetStates}>
              Reset
            </button>
          </div>
          <div className="ml-3">Choose 2 options:</div>
          <StateComp
            tempSelection={tempSelection}
            setTempSelection={setTempSelection}
            displayValue={displayValue}
          />
        </div>
      ) : null}
      {comparator === "Cohort" ? (
        <div className="flex-1 w-full overflow-y-auto rounded-3xl bg-valmainheart p-2">
          <div className="text-5xl text-valmidnight font-bold font-caption-1! ml-3">
            Cohort
          </div>
          <div className="ml-3">Choose 2 options:</div>
          <CohortComp />
        </div>
      ) : null}
      {comparator === "Age" ? (
        <div className="flex-1 w-full overflow-y-auto rounded-3xl bg-valmainheart p-2">
          <div className="text-5xl text-valmidnight font-bold font-caption-1! ml-3">
            Age
          </div>
          <div className="ml-3">Choose 2 options:</div>
          <AgeComp />
        </div>
      ) : null}
      {comparator === "Sex" ? (
        <div className="flex-1 w-full overflow-y-auto rounded-3xl bg-valmainheart p-2">
          <div className="text-5xl text-valmidnight font-bold font-caption-1! ml-3">
            Sex
          </div>
          <div className="ml-3">Choose 2 options:</div>
          <SexComp />
        </div>
      ) : null}
      {comparator === "Insurance" ? (
        <div className="flex-1 w-full overflow-y-auto rounded-3xl bg-valmainheart p-2">
          <div className="text-5xl text-valmidnight font-bold font-caption-1! ml-3">
            Insurance
          </div>
          <div className="ml-3">Choose 2 options:</div>
          <InsuranceComp />
        </div>
      ) : null}
      {comparator === "Year" ? (
        <div className="flex-1 w-full overflow-y-auto rounded-3xl bg-valmainheart p-2">
          <div className="text-5xl text-valmidnight font-bold font-caption-1! ml-3">
            Year
          </div>
          <div className="ml-3">Choose 2 options:</div>
          <YearComp />
        </div>
      ) : null}
    </div>
  );
};

export default ComparatorSelection;
